import { useCallback, useEffect, useRef, useState } from "react";
/** Manages the selected state and focus behaviour for a single tag pill. */
export function useTagItem(tagType, isEditable) {
  var _useState = useState(false),
    isSelected = _useState[0],
    setIsSelectedRaw = _useState[1];
  var containerRef = useRef(null);
  var inputWrapperRef = useRef(null);
  var inputEleRef = useRef(null);

  /** Marks the tag as selected without triggering focus — used by inputWrapper's capture handler. */
  var markSelected = useCallback(function () {
    setIsSelectedRaw(true);
  }, []);

  /** Selects the tag and immediately focuses or activates its input. */
  var onTagClick = useCallback(function () {
    var _inputEleRef$current, _inputEleRef$current2;
    if (!isEditable) return;
    setIsSelectedRaw(true);
    var wrapper = inputWrapperRef.current;
    if (!wrapper) return;
    if (tagType === "multi_dropdown") {
      var _wrapper$querySelecto;
      (_wrapper$querySelecto = wrapper.querySelector("[role='button']")) === null || _wrapper$querySelecto === void 0 || _wrapper$querySelecto.click();
    } else if (tagType === "date") (_inputEleRef$current = inputEleRef.current) === null || _inputEleRef$current === void 0 || _inputEleRef$current.click();else (_inputEleRef$current2 = inputEleRef.current) === null || _inputEleRef$current2 === void 0 || _inputEleRef$current2.focus();
  }, [isEditable, tagType]);
  var handleClickOutside = useCallback(function (e) {
    var _containerRef$current, _document$getElementB;
    var target = e.target;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(target)) return;
    var inPortal = !((_document$getElementB = document.getElementById("__next")) !== null && _document$getElementB !== void 0 && _document$getElementB.contains(target));
    if (inPortal) return;
    setIsSelectedRaw(false);
  }, []);
  useEffect(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);
  return {
    isSelected: isSelected,
    markSelected: markSelected,
    onTagClick: onTagClick,
    containerRef: containerRef,
    inputWrapperRef: inputWrapperRef,
    inputEleRef: inputEleRef
  };
}